import libraryReducer from "./libraryReducer";
import loginReducer from './loginReducer';
import errorReducer from './errorReducer';
import notesReducer from './notesReducer';
import dashboardReducer from './dashboardReducer';
import testReducer from './testReducer';
import jobsReducer from './jobsReducer';
import feedsReducer from './feedsReducer';
import syllabusReducer from './syllabusReducer';
import ContentReducer from './manageContentReducer';
import userReducer from './userReducer';
import accountReducer from './accountReducer';
import sideBarReducer from './sideBarReducer';
import noticeReducer from './noticeReducer';
import myContentReducer from './myContentReducer';
import achieverReducer from './achieverReducer';
import notificationReducer from './notificationReducer';
import profileReducer from './profileReducer';
import reportReducer from './reportReducer';
import reportReducer2 from './reports2Reducer';
import SkillLibReducer from './skillLibReducer';
import SearchReducer from './searchReducer';
import connectReducer from "./connectReducer";
import { combineReducers } from "redux";
import manageScheduleReducer from "./manageScheduleReducer";
import manageAttendanceReducer from "./manageAttendanceReducer";
import totReportReducer from "./totReportReducer";
import manageExamReducer from "./manageExamReducer";
import proctoredTestReducer from "./proctoredTestReducer";
import rewardReducer from "./rewardReducer";
import assignmentReducer from "./assignmentReducer";
import scheduleReducer from "./scheduleReducer";
import whiteboardReducer from "./whiteboardReducer";
import examReducer from "./examReducer";

export const rootReducer = combineReducers({
    login: loginReducer,
    library: libraryReducer,
    dashboard: dashboardReducer,
    notes: notesReducer,
    test: testReducer,
    assignment: assignmentReducer,
    jobs: jobsReducer,
    feeds: feedsReducer,
    error: errorReducer,
    syllabus: syllabusReducer,
    content: ContentReducer,
    user: userReducer,
    account: accountReducer,
    sidebar: sideBarReducer,
    notice: noticeReducer,
    mycontent: myContentReducer,
    achiever: achieverReducer,
    notification: notificationReducer,
    profile: profileReducer,
    report: reportReducer,
    report2:reportReducer2,
    skillLibrary: SkillLibReducer,
    search: SearchReducer,
    connect: connectReducer,
    schedule: manageScheduleReducer,
    attendance: manageAttendanceReducer,
    totReport: totReportReducer,
    totExams: manageExamReducer,
    exams: examReducer,
    proctored: proctoredTestReducer,
    rewards: rewardReducer,
    schedule: scheduleReducer,
    whiteboard: whiteboardReducer
});

